import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { SubjectService } from 'src/app/services/subject.service';

@Component({
  selector: 'app-session-timeout',
  templateUrl: './session-timeout.component.html',
  styleUrls: ['./session-timeout.component.scss'],
})
export class SessionTimeoutComponent implements OnInit {
  @Input() countDownTime: any;
  constructor(
    private SS: SubjectService,
    private modalController: ModalController
  ) { }

  ngOnInit() {
    // let interval;
    // if (this.countDownTime == 15) {
    //   interval = setInterval(() => {
    //     this.countDownTime = this.countDownTime - 1;
    //     if (this.countDownTime == 0) {
    //       clearInterval(interval);
    //     }
    //   }, 1000);
    // }
    let h: any = document.getElementsByClassName('hours');
    let m: any = document.getElementsByClassName('min');
    let s: any = document.getElementsByClassName('sec');
    let now = new Date().getTime();

    let distance = now;
    let minutes: any = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    let seconds: any = this.countDownTime;

    let prev_sec: any = seconds;
    let prev_min: any = minutes;
    s[0].innerHTML = s[2].innerHTML = parseInt((seconds / 10).toString());
    s[1].innerHTML = s[3].innerHTML = parseInt((seconds % 10).toString());
    let timers: number = 15;

    let x = setInterval(() =>{
            // Get today's date and time
      let now = new Date().getTime();
      // Find the distance between now and the count down date
      let distance = now;
      // Time calculations for days, hours, minutes and second

      let minutes: any = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds: any = Math.floor((distance % (1000 * 60)) / 1000);
      let remainingSec = timers--;
     if(remainingSec == 0){
       s[0].innerHTML = s[2].innerHTML = '0';
       s[1].innerHTML = s[3].innerHTML = '0';
       clearInterval(x);
       this.continueSession();
      }else{
        let data = [...remainingSec.toString()];
        if(data.length > 1){
        s[0].innerHTML = s[2].innerHTML = data[0];
        s[1].innerHTML = s[3].innerHTML = data[1];
        }else{
          s[0].innerHTML = s[2].innerHTML = '0';
          s[1].innerHTML = s[3].innerHTML = data[0];
        }
      
      }

      prev_sec = seconds;
      prev_min = minutes
      // prev_hour = hours;
    }, 1000);
  }

  continueSession(): void {
    setTimeout(() => {
      this.SS.continueSession.next(true);
      this.dismiss();
    }, 500);
  }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      dismissed: true,
    });
  }
}
